import { JsonValue } from "@/v2/shared/types";

// HTTP Methods
export const httpMethods = ["GET", "POST", "PUT", "DELETE", "PATCH"] as const;
export type HttpMethod = (typeof httpMethods)[number];

// Authentication Types
export const authTypes = ["basic", "apikey", "bearer"] as const;
export type AuthType = (typeof authTypes)[number];

export const authTypeToLabel = {
  basic: "Basic",
  apikey: "API Key",
  bearer: "Bearer Token",
};

interface BaseAuth {
  type: AuthType;
}

export interface BasicAuth extends BaseAuth {
  type: "basic";
  user: string;
  password: string;
}

export const apiKeyLocationOptions = ["header", "query"] as const;
export type ApiKeyLocation = (typeof apiKeyLocationOptions)[number];

export interface ApiKeyAuth extends BaseAuth {
  type: "apikey";
  key: string;
  value: string;
  location: ApiKeyLocation;
}

export interface BearerAuth extends BaseAuth {
  type: "bearer";
  token: string;
}

export type AuthConfig = BasicAuth | ApiKeyAuth | BearerAuth;

export type QueryParams = Record<string, string | string[]>;
export type PathParams = Record<string, string>;

export interface CurlRequest {
  method: HttpMethod;
  url: string;
  queryParams?: QueryParams; // parsed from ?key=value
  pathParams?: PathParams; // parsed from ${param} in URL path
  headers?: Record<string, string>; // -H "Key: Value"
  body?: JsonValue; // raw string or parsed JSON
  auth?: AuthConfig;
  options?: {
    followRedirects?: boolean; // -L
    insecure?: boolean; // -k
    compressed?: boolean; // --compressed
    timeoutSeconds?: number; // --max-time
    outputFile?: string; // -o file.txt
  };
}
